import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  NOTIFICATIONDELIVERYSTATUS_FAILED,
  NOTIFICATIONDELIVERYSTATUS_SUCCESSFUL,
} from '../../../../../constants/api';
import { getAttr } from '../../../../../features/helpers/apiHelpers';

const InviteeMetaDataInfoBox = ({
  invitedUsers,
  invitedCompanies,
  invitationNotificationQueues,
}) => {
  const { t: translator } = useTranslation();

  const numberOfTotalInvitees = useMemo(() => {
    const numberOfUserInvitees =
      invitedUsers !== null ? invitedUsers.length : 0;
    const numberOfCompanyInvitees =
      invitedCompanies !== null ? invitedCompanies.length : 0;
    return numberOfUserInvitees + numberOfCompanyInvitees;
  }, [invitedUsers, invitedCompanies]);

  const numberOfInvitationsSent = useMemo(
    () =>
      invitationNotificationQueues !== null
        ? invitationNotificationQueues.filter(
            (nq) =>
              getAttr(nq, 'deliveryStatus') ===
              NOTIFICATIONDELIVERYSTATUS_SUCCESSFUL,
          ).length
        : 0,
    [invitationNotificationQueues],
  );

  const numberOfFailedInvitations = useMemo(
    () =>
      invitationNotificationQueues !== null
        ? invitationNotificationQueues.filter(
            (nq) =>
              getAttr(nq, 'deliveryStatus') ===
              NOTIFICATIONDELIVERYSTATUS_FAILED,
          ).length
        : 0,
    [invitationNotificationQueues],
  );

  const numberOfInvitationsToBeSent = useMemo(
    () =>
      numberOfTotalInvitees -
      numberOfInvitationsSent -
      numberOfFailedInvitations,
    [numberOfTotalInvitees, numberOfInvitationsSent, numberOfFailedInvitations],
  );

  return (
    <div className="invitations-info-box">
      <h3>
        {translator(
          'pages.createHearing.createHearingInvitations.inviteeMetaDataInfoBox.header',
        )}{' '}
      </h3>
      <hr className="create-hearing-header-hr" />
      <div className="create-hearing-info-text-field">
        <p className="title">
          {translator(
            'pages.createHearing.createHearingInvitations.inviteeMetaDataInfoBox.numberOfTotalInvitees',
          )}
        </p>
        <p className="value">{numberOfTotalInvitees}</p>
      </div>
      <div className="create-hearing-info-text-field">
        <p className="title">
          {translator(
            'pages.createHearing.createHearingInvitations.inviteeMetaDataInfoBox.numberOfInvitationsToBeSent',
          )}
        </p>
        <p className="value">{numberOfInvitationsToBeSent}</p>
      </div>
      <div className="create-hearing-info-text-field">
        <p className="title">
          {translator(
            'pages.createHearing.createHearingInvitations.inviteeMetaDataInfoBox.numberOfInvitationsSent',
          )}
        </p>
        <p className="value">{numberOfInvitationsSent}</p>
      </div>
      <div className="create-hearing-info-text-field">
        <p className="title">
          {translator(
            'pages.createHearing.createHearingInvitations.inviteeMetaDataInfoBox.numberOfFailedInvitations',
          )}{' '}
        </p>
        <p className="value">{numberOfFailedInvitations}</p>
      </div>
    </div>
  );
};

export { InviteeMetaDataInfoBox };
